import React, { useContext, useState } from 'react';
import { Link } from "react-router-dom";
import { Row, Col, Card, Button } from "react-bootstrap";
import { RiArrowGoBackLine } from 'react-icons/ri';

import ComplementContext from "../../../context/Complement/ComplementContext";

import FormProfile from '../../Profile/form';
import FormSalarySettlement from '../../../components/FormSalarySettlement'

import UsersAdminContext from "../../../context/Admin/Users/UsersAdminContext";
import Loading from "../../../components/Loading";

import { useToasts } from 'react-toast-notifications'
import { warningToast } from "../../../utils/ToastUtil";

const AdminUser = ({history}) => {

  const { addToast } = useToasts();

  const complementContext = useContext(ComplementContext);
  const { afp, isapre, region} = complementContext;

  const usersAdminContext = useContext(UsersAdminContext);
  const { loading, userSelected, saveNewUser, updateUserAdmin} = usersAdminContext;

  const [user, setUser] = useState(null);
  const [contract, setContract] = useState(null);

  const hookUser = (data) => {
    if(data){ setUser(data); }
    else{ setUser(data);}
  }

  const hookContract = (data) => {
    if(data){ setContract(data); }
    else{ setContract(data);}
  }

  const updateUser = async () => { 
    const validation = validationForm();
    if(validation){
      let data = user;
      data.contract = contract;
      data.liquidations=null;
      data.img=null;
      data.infoVacation={dayByMonth: contract.dayByMonth};
      data.run=data.run.replace(/\./g,'');
      const response = await updateUserAdmin(data, data.email);

      if(response){
        history.push(`/admin/user`);
      }else{
        //Nothing
      }
    }
  }

  const saveUser = async () => {
    const validation = validationForm();
    if(validation){
      let data = user;
      data.contract = contract;
      data.liquidations=null;
      data.img=null;
      data.infoVacation={dayByMonth: contract.dayByMonth};
      data.run=data.run.replace(/\./g,'');
      const response = await saveNewUser(data);
      if(response){
        history.push(`/admin/user`);
      }else{
        //Nothing
      }
    }
  }
  
  const validationForm = () => {
    let data = user;
    data.contract = contract;
    data.liquidations=null;
    data.img=null;
    data.infoVacation={dayByMonth: contract.dayByMonth};
    
    if(!data.isMaintainer && data.isMaintainer === ''){data.isMaintainer=false}   

    // Validation Contract Info
    if(!data.contract.typeContract || data.contract.workPosition.trim() === ''){ addToast('Debe Completar campo "Cargo del Trabajador"!', warningToast()); return;}
    if(!data.contract.workPosition || data.contract.workPosition.trim() === ''){ addToast('Debe Completar campo "Cargo del Trabajador"!', warningToast()); return;}
    if(!data.contract.salary || data.contract.salary.trim() === ''){ addToast('Debe Completar campo "Sueldo Bruto"!', warningToast()); return;}
    if(!data.contract.hiringDate || data.contract.hiringDate.trim() === ''){ addToast('Debe Completar campo "Fecha de Contratación"!', warningToast()); return;}
    if(!data.contract.entryTime || data.contract.entryTime.trim() === ''){ addToast('Debe Completar campo "Hora de Entrada"!', warningToast()); return;}
    if(!data.contract.departureTime || data.contract.departureTime.trim() === ''){ addToast('Debe Completar campo "Hora de Sálida"!', warningToast()); return;}
    if(!data.infoVacation.dayByMonth ){ addToast('Debe Completar campo "Días de vacacions por Mes"!', warningToast()); return;}

    // Validation User Info
    if(!data.run || data.run.trim() === ''){ addToast('Debe Completar campo "RUN"!', warningToast()); return;}
    if(!data.firstName || data.firstName.trim() === ''){ addToast('Debe Completar campo "Primer Nombre"!', warningToast()); return;}
    if(!data.secondName || data.secondName.trim() === ''){ addToast('Debe Completar campo "Segundo Nombre"!', warningToast()); return;}
    if(!data.lastName || data.lastName.trim() === ''){ addToast('Debe Completar campo "Apellido Paterno"!', warningToast()); return;}
    if(!data.surName || data.surName.trim() === ''){ addToast('Debe Completar campo "Apellido Materno"!', warningToast()); return;}
    if(!data.nationality || data.nationality.trim() === ''){ addToast('Debe Completar campo "Nacionalidad"!', warningToast()); return;}
    if(!data.civilStatus || data.civilStatus.trim() === ''){ addToast('Debe Completar campo "Estado civil"!', warningToast()); return;}
    if(!data.birthday || data.birthday.trim() === ''){ addToast('Debe Completar campo "Fecha de Nacimineto"!', warningToast()); return;}    
    if(!data.email || data.email.trim() === ''){ addToast('Debe Completar campo "Email"!', warningToast()); return;}
    if(!data.region || data.region.trim() === ''){ addToast('Debe Seleccionar una "Region"!', warningToast()); return;}
    if(!data.comuna || data.comuna.trim() === ''){ addToast('Debe Seleccionar una "Comuna"!', warningToast()); return;}
    if(!data.direction || data.direction.trim() === ''){ addToast('Debe Completar campo de "Dirección"!', warningToast()); return;}
    if((!data.phone || data.phone.trim() === '') && (!data.cellphone || data.cellphone.trim() === '') ){ addToast('Debe ingresar un teléfono Fijo o Celular', warningToast()); return;}
    if(!data.afp || data.afp.trim() === ''){ addToast('Debe Seleccionar una "AFP"!', warningToast()); return;}
    if(!data.isapre || data.isapre.trim() === ''){ addToast('Debe Seleccionar una "Isapre"!', warningToast()); return;}

    // Validation Emergency User Info
    if(!data.emergencyContacts || data.emergencyContacts <= 0){ addToast('Debe Agrear un contacto de emergencia !', warningToast()); return;}
    if(data.emergencyContacts && data.emergencyContacts.length > 0){
      data.emergencyContacts.forEach(element => {
        if(!element.fullName || element.fullName.trim() === ''){ addToast('Debe Completar el campo "Nombre" del contacto de emergencia!', warningToast()); return;}
        else if(!element.email || element.email.trim() === ''){ addToast('Debe Completar el campo "Email" del contacto de emergencia!', warningToast()); return;}
        else if( (!element.phone || element.phone.trim() === '')  &&  (!element.cellphone || element.cellphone.trim() === '')){ addToast('Debe ingresar un teléfono Fijo o Celular del contacto de emergencia' , warningToast()); return;}
      });
    }

    return data;
  }

    return (
        <>
          <Row>
            <Col>
                <h1 className="h3 mb-2 text-gray-800">Administración de Usuarios</h1>
                <hr />
            </Col>
          </Row>

          <Row >   
            <Col lg={4}>
              <Link to={"/admin/user"}>
                <Button   className={"col-lg-10"} variant="outline-secondary">
                  <RiArrowGoBackLine />Atrás
                </Button>
              </Link>
              </Col>        
            <Col lg={8} >         
              {userSelected.run? 
                <Button className={"col-lg-12"} onClick={updateUser} disabled={loading}>Actualizar</Button>: 
                <Button className={"col-lg-12"} onClick={saveUser} disabled={loading}>Agregar</Button>}
              
            </Col>
          </Row>
          <hr />
          <Row>
            <Col lg={6} >
              <Card>
                  <Card.Header>Datos de Contrato</Card.Header>
                  <Card.Body>
                      <Card.Title>Información</Card.Title>
                      
                      <Card.Text>
                        {loading ? <Loading/> : 
                          <FormSalarySettlement
                            contract={userSelected.contract}
                            dayMonth={userSelected.infoVacation ? userSelected.infoVacation.dayByMonth : null}
                            eventParent={hookContract}
                          />}

                      </Card.Text>
                      
                  </Card.Body>
              </Card>
            </Col>
            <Col lg={6} >
              <Card>
                  <Card.Header>Datos del Empleado</Card.Header>
                  <Card.Body>
                      <Card.Title>Usuario</Card.Title>
                      
                      <Card.Text>
                      {loading ? <Loading/> : 
                          <FormProfile 
                              colSize={9} 
                              user={userSelected} 
                              afp={afp} 
                              isapre={isapre} 
                              region={region} 
                              isRoleUser={false}
                              eventParent={hookUser}
                          /> }

                      </Card.Text>
                      
                  </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      );
}
 
export default AdminUser;